import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 218px 1fr;
  border-radius: 9px;
  border: 1px solid ${({ theme }) => theme.colorsNew.gray.grayMedium};
  background: ${({ theme }) => theme.colorsNew.gray.white};
`;

export const Sidebar = styled.div`
  background: ${({ theme }) => theme.colorsNew.gray.grayLight};
  padding: 24px 0;
  border-radius: 9px 0 0 9px;
  border-right: 1px solid ${({ theme }) => theme.colorsNew.gray.grayMedium};
`;

export const CalendarContainer = styled.div`
  padding: 16px;
`;

export const CalendarHeader = styled.div`
  display: flex;
  margin-bottom: 16px;
`;

export const ChangeMonthWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 48px;
  padding: 0 8px;
`;

export const ChangeMonthButton = styled.button`
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  color: 1px solid ${({ theme }) => theme.colorsNew.gray.blackLight};

  :hover {
    color: ${({ theme }) => theme.colorsNew.primaryAction.regular};
    border: 1px solid ${({ theme }) => theme.colorsNew.gray.grayMedium};
  }
`;

export const ChangeMonthMonthName = styled.div`
  ${({ theme }) => theme.typography.H3}
  font-weight: bold;
  text-transform: capitalize;
  margin-left: 4px;
`;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: flex-end;
  margin: 64px 0 24px;

  > * {
    margin-right: 16px;
  }
`;
